import { PaginationResult } from '../../type/pagination'

export interface GetProductsList<T> {
  products: T[]
  pagination: PaginationResult
}

export const PAGE_SIZE = 9
